import { Box } from '@chakra-ui/react'
import { useCallback, useEffect } from 'react'

import { useUser } from '@/client/context/user'
import useOneTimeAcknowledgement from '@/client/hooks/useOneTimeAcknowledgement'
import { getPrivacyUrl, getTermsUrl } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import { useToaster } from '@/components/Toast/useToaster'

let hasPresentedModal = false

export default function PolicyUpdateToast() {
  const user = useUser()
  const toast = useToaster()

  const { acknowledgedAt, onAcknowledgement } = useOneTimeAcknowledgement(
    'privacy-policy-update-2025-02',
    { disableRefresh: true }
  )
  const hasAcknowledged = acknowledgedAt != null
  const shouldPresentToast = !hasAcknowledged && new Date(user.createdAt) < new Date('2025-02-10')

  const presentToast = useCallback(() => {
    if (hasPresentedModal) {
      return
    }
    hasPresentedModal = true

    toast({
      description: (
        <Box>
          We have updated our{' '}
          <ShwLink href={getPrivacyUrl()} color="info.fg">
            Privacy Policy
          </ShwLink>{' '}
          and{' '}
          <ShwLink href={getTermsUrl()} color="info.fg">
            Terms of Service
          </ShwLink>
          .
        </Box>
      ),
      status: 'info',
      duration: null,
      onCloseComplete: onAcknowledgement,
    })
  }, [toast, onAcknowledgement])

  useEffect(() => {
    if (shouldPresentToast) {
      // We add a delay so the toast container has time to mount
      setTimeout(presentToast, 1000)
    }
    // Intentionally only triggering this once, regardless of dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
